import { PageHero } from "../components/PageHero";
import { ContactForm } from "../components/ContactForm";

export function ContactPage() {
  return (
    <main className="no-print flex-grow bg-slate-50 dark:bg-[#070b12] transition-colors">
      {/* Brand Hero Header */}
      <PageHero
        badge="RADIECE Technical Inquiry Desk"
        title="Connect With Engineering"
        subtitle="Direct Project, R&D & Training Consultation"
        description="Discuss your software requirements, custom hardware prototyping, security systems, or institutional training programs with our technical leads in Kakkanad, Ernakulam."
        maxWidth="max-w-5xl"
      />

      {/* Quick Contact Info Cards */}
      <section className="py-12 sm:py-16 bg-white dark:bg-[#0b131e] border-b border-slate-200/80 dark:border-slate-800 transition-colors">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="sr-only">Contact Channels</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8">
            {/* Call Us Card */}
            <div className="bg-slate-50/80 dark:bg-[#0e1724] rounded-2xl p-7 border border-slate-200/80 dark:border-slate-800 flex items-start gap-4 hover:shadow-md hover:border-slate-300 dark:hover:border-slate-700 transition-all duration-300">
              <div className="w-12 h-12 rounded-xl bg-brand/10 dark:bg-primary/15 text-brand dark:text-primary flex items-center justify-center shrink-0 border border-brand/20 dark:border-primary/30">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-2.826-1.47-5.114-3.758-6.584-6.584l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z" />
                </svg>
              </div>
              <div>
                <span className="text-xs font-semibold uppercase tracking-wider text-brand dark:text-primary block mb-1">Direct Helpline</span>
                <h3 className="text-lg font-bold text-brand-dark dark:text-slate-100 mb-1">+91 95675 51437</h3>
                <p className="text-xs text-slate-500 dark:text-slate-400 font-medium">Monday – Saturday: 09:00 AM – 06:00 PM IST</p>
              </div>
            </div>

            {/* Email Us Card */}
            <div className="bg-slate-50/80 dark:bg-[#0e1724] rounded-2xl p-7 border border-slate-200/80 dark:border-slate-800 flex items-start gap-4 hover:shadow-md hover:border-slate-300 dark:hover:border-slate-700 transition-all duration-300">
              <div className="w-12 h-12 rounded-xl bg-brand/10 dark:bg-primary/15 text-brand dark:text-primary flex items-center justify-center shrink-0 border border-brand/20 dark:border-primary/30">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
                </svg>
              </div>
              <div>
                <span className="text-xs font-semibold uppercase tracking-wider text-brand dark:text-primary block mb-1">Official Desk</span>
                <a href="mailto:connect@radiece.com" className="text-lg font-bold text-brand-dark dark:text-slate-100 hover:text-primary dark:hover:text-sky-300 transition-colors block mb-1">
                  connect@radiece.com
                </a>
                <p className="text-xs text-slate-500 dark:text-slate-400 font-medium">24-hour turnaround SLA response time</p>
              </div>
            </div>

            {/* Registered Office Card (Prior Appointment Notice) */}
            <div className="bg-slate-50/80 dark:bg-[#0e1724] rounded-2xl p-7 border border-slate-200/80 dark:border-slate-800 flex items-start gap-4 hover:shadow-md hover:border-slate-300 dark:hover:border-slate-700 transition-all duration-300">
              <div className="w-12 h-12 rounded-xl bg-brand/10 dark:bg-primary/15 text-brand dark:text-primary flex items-center justify-center shrink-0 border border-brand/20 dark:border-primary/30">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
                </svg>
              </div>
              <div>
                <span className="text-xs font-semibold uppercase tracking-wider text-brand dark:text-primary block mb-1">Registered Office</span>
                <h3 className="text-sm font-bold text-brand-dark dark:text-slate-100 mb-1 leading-snug">
                  Suite 1034, Heiley Offices, 2nd Floor KC Arcade
                </h3>
                <p className="text-xs text-slate-500 dark:text-slate-400 leading-relaxed mb-2">
                  Near TV Centre, CSEZ P.O, Kakkanad, Ernakulam - 682037
                </p>
                <div className="flex flex-wrap items-center gap-1.5 mt-2">
                  <span className="inline-block text-[11px] font-semibold text-slate-700 dark:text-slate-300 bg-slate-200/80 dark:bg-slate-800 border border-slate-300 dark:border-slate-700 px-2 py-0.5 rounded">
                    In-Person Visits By Prior Booking
                  </span>
                </div>
                <div className="mt-2.5 pt-2 border-t border-slate-200/80 dark:border-slate-800 flex flex-wrap items-center gap-x-2 text-[10px] font-mono text-slate-500 dark:text-slate-400">
                  <span>CIN: U58200KL2026PTC104862</span>
                  <span>•</span>
                  <span>GSTIN: 32AAQCR1162B1ZR</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Adaptive Contact Form Section */}
      <section className="py-12 sm:py-16">
        <ContactForm />
      </section>

      {/* Google Maps Location Section */}
      <section className="py-16 bg-white dark:bg-[#0b131e] border-t border-slate-200/80 dark:border-slate-800 transition-colors">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-2xl mx-auto mb-8">
            <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-blue-50 dark:bg-primary/10 border border-blue-100 dark:border-primary/20 text-brand dark:text-primary text-xs font-semibold uppercase tracking-wider mb-2">
              Registered Office Location
            </span>
            <h2 className="text-3xl sm:text-4xl font-extrabold text-brand-dark dark:text-slate-100 tracking-tight">
              Location Map
            </h2>
            <p className="text-sm sm:text-base text-slate-600 dark:text-slate-300 mt-2 leading-relaxed">
              Suite No. 1034, Heiley Offices, 2nd Floor KC Arcade, Near TV Centre, CSEZ P.O, Kakkanad, Ernakulam, Kerala
            </p>
          </div>

          {/* Visitor Appointment Notice */}
          <div className="max-w-3xl mx-auto bg-amber-50 dark:bg-amber-950/40 border border-amber-200 dark:border-amber-800/60 rounded-xl p-4 mb-8 text-center text-xs sm:text-sm text-amber-900 dark:text-amber-200 font-medium shadow-xs">
            📢 <strong>Important Visitor Guidelines:</strong> Our Kakkanad registered office handles corporate legal and administrative operations. To ensure technical team availability, <strong>all visits must be scheduled in advance</strong> via email (<a href="mailto:connect@radiece.com" className="underline font-bold hover:text-brand dark:hover:text-primary">connect@radiece.com</a>) or phone (<a href="tel:+919567551437" className="underline font-bold hover:text-brand dark:hover:text-primary">+91 95675 51437</a>). Walk-in inquiries are politely redirected to digital/phone channels.
          </div>

          <div className="overflow-hidden rounded-2xl shadow-md border border-slate-200/90 dark:border-slate-800 bg-slate-100 dark:bg-[#0e1724]">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3929.118639329323!2d76.3385083!3d10.007057999999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6663c82104dc4fef%3A0x8ee7e9d406c388e2!2sRADIECE%20PRIVATE%20LIMITED!5e0!3m2!1sen!2sin!4v1784988640221!5m2!1sen!2sin"
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="strict-origin-when-cross-origin"
              title="RADIECE PRIVATE LIMITED Location Map"
              className="w-full h-[380px] sm:h-[480px]"
            />
          </div>
        </div>
      </section>
    </main>
  );
}
